import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-neutral-100 border-y border-neutral-200" data-id="element-319" data-mp="3sqbmhm39w97g">
      <div className="max-w-7xl mx-auto px-4" data-id="element-320" data-mp="3ssent29vlorh">
        <div className="text-center mb-7" data-id="element-321" data-mp="3nzbosembxn3w">
          <h2 className="text-neutral-900 font-bold tracking-widest uppercase text-sm" data-id="element-322" data-mp="3nyab02dximih">
            What Heavy Equipment Instructors Are Saying
          </h2>
          <p className="text-xs text-neutral-800/60 mt-2 max-w-2xl mx-auto" data-id="element-323" data-mp="nat5dvg60ef">
            The following are fictional sample testimonials for layout purposes, not verified
            customer reviews. Replace them with authentic feedback before publishing the page.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-324" data-mp="2had7z2pbsuyu">
          {testimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-neutral-200 p-6 rounded-2xl shadow-sm shadow-neutral-900/5 flex flex-col" data-id="element-325" data-mp="2cd3mfy5253ga" data-mpi={index}>
              <div className="flex gap-1 text-amber-500 mb-4" aria-label="5 out of 5 stars" data-id="element-326" data-mp="q5f3btwqg29c">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" aria-hidden="true" data-id="element-327" data-mp="101s75klzrwht" data-mpi={starIndex} />)}
              </div>
              <p className="text-neutral-800 italic mb-6 text-sm leading-relaxed" data-id="element-328" data-mp="1456pwj1beqyy">
                “{testimonial.text}”
              </p>
              <div className="mt-auto pt-4 border-t border-neutral-200" data-id="element-329" data-mp="190m1t5fricsq">
                <div className="font-bold text-neutral-900 text-sm" data-id="element-330" data-mp="35wt93yeythkv">{testimonial.name}</div>
                {testimonial.role && <div className="text-xs text-amber-700 font-semibold mt-0.5" data-id="element-331" data-mp="hzuumsg4xtzc">{testimonial.role}</div>}
                <div className="flex items-center gap-1.5 text-xs text-neutral-800/60 mt-1.5" data-id="element-332" data-mp="d1b6qmhze84c">
                  <img src={`https://flagcdn.com/${testimonial.countryCode}.svg`} alt="" aria-hidden="true" className="w-[18px] h-[13px] rounded-[2px] object-cover shrink-0 ring-1 ring-black/5" data-id="element-333" data-mp="r0atfolxocxv" />
                  {testimonial.country}
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}